import { FormControl, Grid, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material'
import React, { forwardRef, useImperativeHandle, useMemo, useState } from 'react'

const AssignLocationSelect = ({ values, name, onChange, value, label, error }) => {
  const values_ = useMemo(() => {
    return values.map((l) => {
      return (
        <MenuItem key={l.id} value={l.id}>
          {l.Name}
        </MenuItem>
      )
    })
  }, [values])
  return (
    <Grid width="100%" item>
      <FormControl
        error={error}
        sx={{
          width: '100%',
          marginTop: '.5em'
        }}>
        <InputLabel id={`select-${name}`}>{label}</InputLabel>
        <Select
          labelId={`select-${name}`}
          label={label}
          value={value}
          error={error}
          defaultValue=""
          onChange={(event) => {
            onChange(event.target.value)
          }}
          sx={{ width: '100%' }}>
          {values_}
        </Select>
      </FormControl>
    </Grid>
  )
}

export const AssignLocation = forwardRef(function AssignLocation_({ data, customers, sites, locations }, ref) {
  const [errors, setErrors] = useState({
    customer: undefined,
    site: undefined,
    location: undefined
  })
  const [values, setValues] = useState({
    screen: data.screen || '',
    customer: data.customer || '',
    site: data.site || '',
    location: data.location || ''
  })

  useImperativeHandle(ref, () => {
    return {
      validate: () => {
        const errors_ = {
          customer: undefined,
          site: undefined,
          location: undefined
        }
        let error = false
        for (const key in values) {
          if (key === 'screen') {
            continue
          }
          if (!error) {
            error = !values[key]
          }
          errors_[key] = !values[key]
        }
        setErrors(errors_)

        return {
          error,
          values
        }
      }
    }
  })

  return (
    <Grid flexDirection="column" container spacing={1} alignItems="center">
      <Grid width="100%" item>
        <OutlinedInput
          onChange={(event) => {
            setValues((values) => {
              return {
                ...values,
                screen: event.target.value
              }
            })
          }}
          value={values.screen}
          placeholder="Screen name"
          color="secondary"
          fullWidth
        />
      </Grid>

      <AssignLocationSelect
        values={customers}
        value={values.customer}
        label="Select customer (required)"
        name="customer"
        error={errors.customer}
        onChange={(value) => {
          setValues((values) => {
            return {
              ...values,
              customer: value
            }
          })

          if (errors.customer) {
            setErrors((errors) => {
              return {
                ...errors,
                customer: !value
              }
            })
          }
        }}
      />

      <AssignLocationSelect
        name="site"
        label="Select site (required)"
        values={sites.filter((s) => s.CustomerId === values.customer)}
        value={values.site ?? ''}
        error={errors.site}
        onChange={(value) => {
          setValues((values) => {
            return {
              ...values,
              site: value
            }
          })
          if (errors.site) {
            setErrors((errors) => {
              return {
                ...errors,
                site: !value
              }
            })
          }
        }}
      />

      <AssignLocationSelect
        name="location"
        label="Select location (required)"
        values={locations.filter((s) => s.SiteId === values.site)}
        value={values.location ?? ''}
        error={errors.location}
        onChange={(value) => {
          setValues((values) => {
            return {
              ...values,
              location: value
            }
          })
          if (errors.location) {
            setErrors((errors) => {
              return {
                ...errors,
                location: !value
              }
            })
          }
        }}
      />
    </Grid>
  )
})
